var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[_c('router-view')],1),_c('v-footer',{attrs:{"padless":"","color":"transparent"}},[_c('v-col',{staticClass:"text-center pt-5 pb-10 footertext",attrs:{"cols":"12"}},[_vm._v(" © TOHO CO., LTD. ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }